module.exports = __webpack_public_path__ + "media/images/sp/page_common/banner/banner_costumes@2x-312ab929563bb1e5600c3b2665b61682.webp";